export const BootIntercom = (data = {}) => {
	window.Intercom("shutdown");
	window.Intercom("boot", {
		app_id: "kn9dtb78",
		...data,
	});
};
